import React from "react";
import { Button, Typography, TableCell, TableRow, TextField } from "@mui/material";
import Select from "react-select";
import MultiLineCreatableSelect from "../HseSavedReportModal/MultiLineCreatableSelect";
import CancelIcon from "@mui/icons-material/Cancel";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import InfoIcon from "@mui/icons-material/Info";
import CheckIcon from "@mui/icons-material/Check";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import InsertPhotoOutlinedIcon from "@mui/icons-material/InsertPhotoOutlined";
import DialogBox from "../DialogBox/DialogBox";
import { toast } from "react-toastify";

// Prevents individual rows from re-rendering when sibling rows change
const HseObservationRow = React.memo(
  ({
    observation,
    index,
    tableType,
    isEditing,
    currentEditedRow,
    selectedObservations,
    safeGroupedObservations,
    selectedObservation,
    openDialog,
    dialog,
    allData,
    areaList,
    equipmentList,
    hseCategoryList,
    checkpointList,
    criticalityOptionList,
    statusOptionList,
    customSelectStylesCreatable,
    editedObservations,
    observations,
    handleCellEdit,
    handleDeleteRow,
    handleEditNewRow,
    handleEditFieldFocus,
    handleEditFieldBlur,
    handleOpenImageDialog,
    handleCloseImageDialog,
    handleRemoveImage,
    handleImageUpload,
    handleDialogBoxObservation,
    handleScoreChange,
    getObservationVariants,
    isFieldDisabled,
    populateHseCategoryList,
    populateCheckpointList,
    populateCriticalityList,
    populateStatusList,
    setIsEditing,
    setCurrentEditedRow,
    setNewObservationAdded,
    setIsReportEdited,
    setSelectedImage,
    setIsEditAreaDropdownOpen,
    setIsEditEquipmentDropdownOpen,
    setIsEditCategoryDropdownOpen,
    setIsEditCheckpointDropdownOpen,
    setAreaList,
    setCheckpointList,
    setEquipmentList,
    setHseCategoryList,
    setEditedObservations,
    setEditInputValues,
    setObservations,
    setSafeGroupedObservations,
    setSelectedObservations,
    editAreaSelectRef,
    editEquipmentSelectRef,
    editCategorySelectRef,
    editCheckpointSelectRef,
    measureRef,
    dataIndex,
    setOpenGallery,
    setCurrentTableType,
    bulkUploadedImages,
    handleUnassignBulkImageFromRow,
    handleAssignBulkImageToRow,
  }) => {
    return (
                                  <TableRow
                                    // measureRef lets @tanstack/react-virtual measure this
                                    // row's real height; data-index tells it which row this
                                    // is. aria-rowindex keeps the true (1-based, header
                                    // -offset) position for screen readers even though
                                    // off-screen rows are not in the DOM under virtualization.
                                    ref={measureRef}
                                    data-index={dataIndex}
                                    aria-rowindex={index + 2}
                                    className={
                                      (isEditing &&
                                        currentEditedRow === (observation.sr_no)) ||
                                        !isEditing
                                        ? "even-row"
                                        : "odd-row"
                                    }
                                    style={{
                                      ...(observation.variant === true
                                        ? { backgroundColor: "#f2f2f2" }
                                        : {}),
                                    }}
                                  >
                                    <TableCell>{index + 1}</TableCell>
                                    {/* area */}
                                    <TableCell
                                      className="editable-cell"
                                      style={{ height: "100px" }}
                                    >
                                      <div
                                        className="cell-content"
                                        style={{
                                          color:
                                            isEditing &&
                                              currentEditedRow !==
                                              observation.sr_no
                                              ? "grey"
                                              : "black",
                                        }}
                                      >
                                        <MultiLineCreatableSelect
                                          ref={editAreaSelectRef}
                                          placeholder="Area"
                                          multiline={false}
                                          options={areaList}
                                          value={observation.area || ""}
                                          clearAriaLabel="Clear Area and delete row"
                                          onBeforeClear={() => {
                                            const isCurrentEditedRow =
                                              isEditing &&
                                              (currentEditedRow === observation.sr_no ||
                                                currentEditedRow === observation.id);
                                            if (!isCurrentEditedRow) {
                                              return true;
                                            }
                                            const confirmed = window.confirm(
                                              "Clearing Area will delete this observation row. Continue?"
                                            );
                                            if (!confirmed) {
                                              return false;
                                            }
                                            handleDeleteRow(
                                              observation.table_type,
                                              observation.area,
                                              observation.sr_no || observation.id,
                                              true
                                            );
                                            return false;
                                          }}
                                          onSelect={(val) => handleCellEdit(
                                            { label: val, value: val },
                                            index,
                                            "area",
                                            observation.area,
                                            observation
                                          )}
                                          onFocus={() => handleEditFieldFocus(observation.sr_no, "area")}
                                          onBlur={() => handleEditFieldBlur(observation.sr_no, "area")}
                                          onMenuOpen={() => {
                                            if (observation.area) {
                                              setEditInputValues((prev) => ({
                                                ...prev,
                                                [`${observation.sr_no}-area`]: observation.area,
                                              }));
                                            }
                                            setIsEditAreaDropdownOpen(true);
                                            // Populate area list filtered by table_type
                                            const filteredData = (allData?.data || []).filter((e) => e.table_type === observation.table_type);
                                            const uniqueAreaList = [...new Set(filteredData.map((e) => e.area))];
                                            setAreaList(uniqueAreaList);
                                          }}
                                          onMenuClose={() => setIsEditAreaDropdownOpen(false)}
                                          menuPortalTarget={document.body}
                                          isDisabled={isFieldDisabled(observation)}
                                        />
                                      </div>
                                    </TableCell>
                                    {/* Equipment */}
                                    <TableCell
                                      className="editable-cell"
                                      style={{ height: "100px" }}
                                    >
                                      <div
                                        className="cell-content"
                                        style={{
                                          color:
                                            isEditing &&
                                              currentEditedRow !==
                                              observation.sr_no
                                              ? "grey"
                                              : "black",
                                        }}
                                      >
                                        <MultiLineCreatableSelect
                                          ref={editEquipmentSelectRef}
                                          placeholder="Equipment"
                                          multiline={false}
                                          options={equipmentList}
                                          value={observation.equipment || ""}
                                          onSelect={(val) => {
                                            const proceed = handleCellEdit(
                                              { label: val, value: val },
                                              index,
                                              "equipment",
                                              observation.equipment,
                                              observation
                                            );
                                            if (proceed !== false && val) {
                                              populateHseCategoryList(val, "equipment", observation.area);
                                            }
                                          }}
                                          onFocus={() => handleEditFieldFocus(observation.sr_no, "equipment")}
                                          onBlur={() => handleEditFieldBlur(observation.sr_no, "equipment")}
                                          onMenuOpen={() => {
                                            if (observation.equipment) {
                                              setEditInputValues((prev) => ({
                                                ...prev,
                                                [`${observation.sr_no}-equipment`]: observation.equipment,
                                              }));
                                            }
                                            setIsEditEquipmentDropdownOpen(true);
                                            if (observation.area) {
                                              const equipment = (allData?.data || [])
                                                .filter((e) => e.area === observation.area)
                                                .map((e) => e.equipment);
                                              const uniqueEquipmentList = [...new Set(equipment)];
                                              setEquipmentList(uniqueEquipmentList);
                                            }
                                          }}
                                          onMenuClose={() => setIsEditEquipmentDropdownOpen(false)}
                                          menuPortalTarget={document.body}
                                          isDisabled={isFieldDisabled(observation)}
                                        />
                                      </div>
                                    </TableCell>
                                    {/* Category */}
                                    <TableCell
                                      className="editable-cell"
                                      style={{ height: "100px" }}
                                    >
                                      <div
                                        className="cell-content"
                                        style={{
                                          color:
                                            isEditing &&
                                              currentEditedRow !== observation.sr_no
                                              ? "grey"
                                              : "black",
                                        }}
                                      >
                                        <MultiLineCreatableSelect
                                          ref={editCategorySelectRef}
                                          placeholder="Category"
                                          multiline={false}
                                          options={hseCategoryList}
                                          value={observation.category || ""}
                                          onSelect={(val) => {
                                            const proceed = handleCellEdit(
                                              { label: val, value: val },
                                              index,
                                              "category",
                                              observation.category,
                                              observation
                                            );
                                            if (proceed !== false && val) {
                                              populateCheckpointList(val, "category", observation.area, observation.equipment);
                                            }
                                          }}
                                          onFocus={() => handleEditFieldFocus(observation.sr_no, "category")}
                                          onBlur={() => handleEditFieldBlur(observation.sr_no, "category")}
                                          onMenuOpen={() => {
                                            if (observation.category) {
                                              setEditInputValues((prev) => ({
                                                ...prev,
                                                [`${observation.sr_no}-category`]: observation.category,
                                              }));
                                            }
                                            setIsEditCategoryDropdownOpen(true);
                                            if (observation.equipment && observation.area) {
                                              const category = (allData?.data || [])
                                                .filter((e) => e.equipment === observation.equipment && e.area === observation.area)
                                                .map((e) => e.category);
                                              const uniqueCategoryList = [...new Set(category)];
                                              setHseCategoryList(uniqueCategoryList);
                                            }
                                          }}
                                          onMenuClose={() => setIsEditCategoryDropdownOpen(false)}
                                          menuPortalTarget={document.body}
                                          isDisabled={isFieldDisabled(observation)}
                                        />
                                      </div>
                                    </TableCell>
                                    {/* checkpoints */}
                                    <TableCell
                                      className="editable-cell"
                                      style={{ height: "100px" }}
                                    >
                                      <div
                                        className="cell-content"
                                        style={{
                                          color:
                                            isEditing &&
                                              currentEditedRow !== observation.sr_no
                                              ? "grey"
                                              : "black",
                                        }}
                                      >
                                        <MultiLineCreatableSelect
                                          ref={editCheckpointSelectRef}
                                          placeholder="Check Point"
                                          multiline={isEditing && currentEditedRow === observation.sr_no}
                                          options={checkpointList}
                                          value={observation.check_points || ""}
                                          onSelect={(val) => {
                                            const proceed = handleCellEdit(
                                              { label: val, value: val },
                                              index,
                                              "check_points",
                                              observation.check_points,
                                              observation
                                            );
                                            if (proceed !== false && val) {
                                              populateCriticalityList(val, "check_points", observation.area, observation.equipment, observation.category);
                                            }
                                          }}
                                          onFocus={() => handleEditFieldFocus(observation.sr_no, "check_points")}
                                          onBlur={() => handleEditFieldBlur(observation.sr_no, "check_points")}
                                          onMenuOpen={() => {
                                            if (observation.check_points) {
                                              setEditInputValues((prev) => ({
                                                ...prev,
                                                [`${observation.sr_no}-check_points`]: observation.check_points,
                                              }));
                                            }
                                            setIsEditCheckpointDropdownOpen(true);
                                            if (observation.category && observation.area && observation.equipment) {
                                              const checkpoints = (allData?.data || [])
                                                .filter((e) => e.category === observation.category && e.area === observation.area && e.equipment === observation.equipment)
                                                .map((e) => e.check_points);
                                              const uniqueCheckpointList = [...new Set(checkpoints)];
                                              setCheckpointList(uniqueCheckpointList);
                                            }
                                          }}
                                          onMenuClose={() => setIsEditCheckpointDropdownOpen(false)}
                                          menuPortalTarget={document.body}
                                          isDisabled={isFieldDisabled(observation)}
                                        />
                                      </div>
                                    </TableCell>

                                    {/* criticality */}
                                    <TableCell className="editable-cell" style={{ height: "100px" }}>
                                      {/* <Select
                                        styles={{
                                          ...customSelectStylesCreatable,
                                        }}
                                        placeholder="Criticality"
                                        options={(() => {
                                          if (observation.check_points && observation.area && observation.equipment && observation.category) {
                                            const criticality = (allData?.data || [])
                                              .filter((e) => e.check_points === observation.check_points && e.area === observation.area && e.equipment === observation.equipment && e.category === observation.category)
                                              .map((e) => e.criticality);
                                            const uniqueCriticalityList = [...new Set(criticality)];
                                            const optionsToUse = uniqueCriticalityList.length > 0 ? uniqueCriticalityList : criticalityOptionList;
                                            return optionsToUse.map((criticality) => ({ label: criticality, value: criticality }));
                                          }
                                          return [];
                                        })()}
                                        noOptionsMessage={() => "No options"}
                                        value={
                                          observation.criticality
                                            ? { label: observation.criticality, value: observation.criticality }
                                            : null
                                        }
                                        isSearchable={false}
                                        isClearable
                                        onChange={(selectedOption) => {
                                          if (currentEditedRow !== -1 && currentEditedRow !== observation.sr_no) {
                                            toast.warning("Please save the current row before editing another.");
                                            return;
                                          }

                                          if (selectedOption) {
                                            const newValue = selectedOption.value;

                                            const proceed = handleCellEdit(
                                              { value: newValue },
                                              index,
                                              "criticality",
                                              observation.criticality,
                                              { ...observation, criticality: newValue }
                                            );

                                            if (!proceed) return;

                                            populateStatusList(observation.area, observation.equipment, observation.category, newValue);
                                          } else {
                                            handleCellEdit(
                                              { value: "" },
                                              index,
                                              "criticality",
                                              observation.criticality,
                                              { ...observation, criticality: "", status: "", observation: "", recommendations: "", legal_reference: "" }
                                            );
                                          }
                                        }}
                                        isDisabled={
                                          isFieldDisabled(observation) ||
                                          observation.variant === true
                                        }
                                        menuPlacement="auto"
                                      /> */}
                                      <MultiLineCreatableSelect
                                        placeholder="Criticality"
                                        multiline={false}
                                        allowCreate={false}
                                        options={(() => {
                                          if (
                                            observation.check_points &&
                                            observation.area &&
                                            observation.equipment &&
                                            observation.category
                                          ) {
                                            const criticality = (allData?.data || [])
                                              .filter(
                                                (e) =>
                                                  e.check_points === observation.check_points &&
                                                  e.area === observation.area &&
                                                  e.equipment === observation.equipment &&
                                                  e.category === observation.category
                                              )
                                              .map((e) => e.criticality);

                                            const uniqueCriticalityList = [
                                              ...new Set(criticality),
                                            ];

                                            return uniqueCriticalityList.length > 0
                                              ? uniqueCriticalityList
                                              : criticalityOptionList;
                                          }

                                          return [];
                                        })()}
                                        value={observation.criticality || ""}
                                        onChange={(val) => {
                                          if (
                                            currentEditedRow !== -1 &&
                                            currentEditedRow !== observation.sr_no
                                          ) {
                                            toast.warning(
                                              "Please save the current row before editing another."
                                            );
                                            return;
                                          }

                                          if (val) {
                                            const proceed = handleCellEdit(
                                              { value: val },
                                              index,
                                              "criticality",
                                              observation.criticality,
                                              {
                                                ...observation,
                                                criticality: val,
                                              }
                                            );

                                            if (!proceed) return;

                                            populateStatusList(
                                              observation.area,
                                              observation.equipment,
                                              observation.category,
                                              val
                                            );
                                          } else {
                                            handleCellEdit(
                                              { value: "" },
                                              index,
                                              "criticality",
                                              observation.criticality,
                                              {
                                                ...observation,
                                                criticality: "",
                                                status: "",
                                                observation: "",
                                                recommendations: "",
                                                legal_reference: "",
                                              }
                                            );
                                          }
                                        }}
                                        isDisabled={
                                          isFieldDisabled(observation) ||
                                          observation.variant === true
                                        }
                                        menuPortalTarget={document.body}
                                      />
                                    </TableCell>

                                    {/* Status */}
                                    <TableCell className="editable-cell" style={{ height: "100px" }}>
                                      {/* <Select
                                        styles={{
                                          ...customSelectStylesCreatable,
                                        }}
                                        placeholder="Status"
                                        options={(() => {
                                          if (observation.area && observation.equipment && observation.category && observation.criticality) {
                                            const statuses = (allData?.data || [])
                                              .filter((e) => {
                                                let match = true;
                                                if (observation.area) match = match && e.area === observation.area;
                                                if (observation.equipment) match = match && e.equipment === observation.equipment;
                                                if (observation.category) match = match && e.category === observation.category;
                                                if (observation.criticality) match = match && e.criticality === observation.criticality;
                                                return match;
                                              })
                                              .map((e) => e.status);
                                            const uniqueStatusList = [...new Set(statuses)];
                                            const optionsToUse = uniqueStatusList.length > 0 ? uniqueStatusList : statusOptionList;
                                            return optionsToUse.map((status) => ({ label: status, value: status }));
                                          }
                                          return [];
                                        })()}
                                        noOptionsMessage={() => "No options"}
                                        value={
                                          observation.status
                                            ? { label: observation.status, value: observation.status }
                                            : null
                                        }
                                        isSearchable={false}
                                        isClearable
                                        onChange={(selectedOption) => {
                                          if (currentEditedRow !== -1 && currentEditedRow !== observation.sr_no) {
                                            toast.warning("Please save the current row before editing another.");
                                            return;
                                          }

                                          if (selectedOption) {
                                            const newValue = selectedOption.value;

                                            const proceed = handleCellEdit(
                                              { value: newValue },
                                              index,
                                              "status",
                                              observation.status,
                                              { ...observation, status: newValue }
                                            );

                                            if (!proceed) return;
                                          } else {
                                            handleCellEdit(
                                              { value: "" },
                                              index,
                                              "status",
                                              observation.status,
                                              { ...observation, status: "", observation: "", recommendations: "", legal_reference: "" }
                                            );
                                          }
                                        }}
                                        isDisabled={
                                          isFieldDisabled(observation) ||
                                          observation.variant === true
                                        }
                                        menuPlacement="auto"
                                      /> */}
                                      <MultiLineCreatableSelect
                                        placeholder="Status"
                                        multiline={false}
                                        allowCreate={false}
                                        options={(() => {
                                          if (
                                            observation.area &&
                                            observation.equipment &&
                                            observation.category &&
                                            observation.criticality
                                          ) {
                                            const statuses = (allData?.data || [])
                                              .filter((e) => {
                                                let match = true;

                                                if (observation.area)
                                                  match =
                                                    match &&
                                                    e.area === observation.area;

                                                if (observation.equipment)
                                                  match =
                                                    match &&
                                                    e.equipment ===
                                                    observation.equipment;

                                                if (observation.category)
                                                  match =
                                                    match &&
                                                    e.category ===
                                                    observation.category;

                                                if (observation.criticality)
                                                  match =
                                                    match &&
                                                    e.criticality ===
                                                    observation.criticality;

                                                return match;
                                              })
                                              .map((e) => e.status);

                                            const uniqueStatusList = [
                                              ...new Set(statuses),
                                            ];

                                            return uniqueStatusList.length > 0
                                              ? uniqueStatusList
                                              : statusOptionList;
                                          }

                                          return [];
                                        })()}
                                        value={observation.status || ""}
                                        onChange={(val) => {
                                          if (
                                            currentEditedRow !== -1 &&
                                            currentEditedRow !== observation.sr_no
                                          ) {
                                            toast.warning(
                                              "Please save the current row before editing another."
                                            );
                                            return;
                                          }

                                          if (val) {
                                            const proceed = handleCellEdit(
                                              { value: val },
                                              index,
                                              "status",
                                              observation.status,
                                              {
                                                ...observation,
                                                status: val,
                                              }
                                            );

                                            if (!proceed) return;
                                          } else {
                                            handleCellEdit(
                                              { value: "" },
                                              index,
                                              "status",
                                              observation.status,
                                              {
                                                ...observation,
                                                status: "",
                                                observation: "",
                                                recommendations: "",
                                                legal_reference: "",
                                              }
                                            );
                                          }
                                        }}
                                        isDisabled={
                                          isFieldDisabled(observation) ||
                                          observation.variant === true
                                        }
                                        menuPortalTarget={document.body}
                                      />
                                    </TableCell>

                                    {/* observation */}
                                    <TableCell className="editable-cell" style={{ height: "100px" }}>
                                      <div
                                        className="cell-content"
                                        style={{
                                          color:
                                            isEditing &&
                                              currentEditedRow !== observation.sr_no
                                              ? "grey"
                                              : "black",
                                        }}
                                      >
                                        <MultiLineCreatableSelect
                                          placeholder="Observation"
                                          multiline={isEditing && currentEditedRow === observation.sr_no}
                                          options={(() => {
                                            if (observation.area && observation.equipment && observation.category && observation.check_points && observation.criticality && observation.status) {
                                              const observations = (allData?.data || [])
                                                .filter((e) => {
                                                  let match = true;
                                                  if (observation.area) match = match && e.area === observation.area;
                                                  if (observation.equipment) match = match && e.equipment === observation.equipment;
                                                  if (observation.category) match = match && e.category === observation.category;
                                                  if (observation.check_points) match = match && e.check_points === observation.check_points;
                                                  if (observation.criticality) match = match && e.criticality === observation.criticality;
                                                  if (observation.status) match = match && e.status === observation.status;
                                                  return match;
                                                })
                                                .map((e) => e.observation);
                                              const uniqueObservationList = [...new Set(observations)];
                                              return uniqueObservationList;
                                            }
                                            return [];
                                          })()}
                                          value={observation.observation || ""}
                                          onSelect={(val) =>
                                            handleCellEdit(
                                              { label: val, value: val },
                                              index,
                                              "observation",
                                              observation.observation,
                                              observation
                                            )
                                          }
                                          onFocus={() => handleEditFieldFocus(observation.sr_no, "observation")}
                                          onBlur={() => handleEditFieldBlur(observation.sr_no, "observation")}
                                          onMenuOpen={() => {
                                            if (observation.observation) {
                                              setEditInputValues((prev) => ({
                                                ...prev,
                                                [`${observation.sr_no}-observation`]: observation.observation,
                                              }));
                                            }
                                          }}
                                          menuPortalTarget={document.body}
                                          isDisabled={isFieldDisabled(observation)}
                                        />
                                        <DialogBox dialog={dialog} handleDialogBox={handleDialogBoxObservation} />
                                      </div>
                                    </TableCell>

                                    {/* recommendations */}
                                    <TableCell className="editable-cell" style={{ height: "100px" }}>
                                      <div
                                        className="cell-content"
                                        style={{
                                          color:
                                            isEditing &&
                                              currentEditedRow !== observation.sr_no
                                              ? "grey"
                                              : "black",
                                        }}
                                      >
                                        <MultiLineCreatableSelect
                                          placeholder="Recommendations"
                                          multiline={isEditing && currentEditedRow === observation.sr_no}
                                          options={(() => {
                                            if (observation.area && observation.equipment && observation.category && observation.check_points && observation.criticality && observation.status) {
                                              const recommendations = (allData?.data || [])
                                                .filter((e) => {
                                                  let match = true;
                                                  if (observation.area) match = match && e.area === observation.area;
                                                  if (observation.equipment) match = match && e.equipment === observation.equipment;
                                                  if (observation.category) match = match && e.category === observation.category;
                                                  if (observation.check_points) match = match && e.check_points === observation.check_points;
                                                  if (observation.criticality) match = match && e.criticality === observation.criticality;
                                                  if (observation.status) match = match && e.status === observation.status;
                                                  return match;
                                                })
                                                .map((e) => e.recommendations?.trim())
                                                .filter(Boolean);
                                              const uniqueRecommendationList = [...new Set(recommendations)];
                                              if (uniqueRecommendationList.length === 0) return ["N/A"];
                                              return uniqueRecommendationList;
                                            }
                                            return [];
                                          })()}
                                          value={observation.recommendations || ""}
                                          onSelect={(val) =>
                                            handleCellEdit(
                                              { label: val, value: val },
                                              index,
                                              "recommendations",
                                              observation.recommendations,
                                              observation
                                            )
                                          }
                                          onFocus={() => handleEditFieldFocus(observation.sr_no, "recommendations")}
                                          onBlur={() => handleEditFieldBlur(observation.sr_no, "recommendations")}
                                          onMenuOpen={() => {
                                            if (observation.recommendations) {
                                              setEditInputValues((prev) => ({
                                                ...prev,
                                                [`${observation.sr_no}-recommendations`]: observation.recommendations,
                                              }));
                                            }
                                          }}
                                          menuPortalTarget={document.body}
                                          isDisabled={isFieldDisabled(observation)}
                                        />
                                      </div>
                                    </TableCell>
                                    {/* legal reference */}
                                    <TableCell
                                      className="editable-cell"
                                      style={{ height: "100px" }}
                                    >
                                      <div
                                        className="cell-content"
                                        style={{
                                          color:
                                            isEditing &&
                                              currentEditedRow !== observation.sr_no
                                              ? "grey"
                                              : "black",
                                        }}
                                      >
                                        <MultiLineCreatableSelect
                                          placeholder="Legal Reference"
                                          multiline={false}
                                          options={(() => {
                                            if (observation.area && observation.equipment && observation.category && observation.check_points && observation.criticality && observation.status) {
                                              const legalReferences = (allData?.data || [])
                                                .filter((e) => {
                                                  let match = true;
                                                  if (observation.area) match = match && e.area === observation.area;
                                                  if (observation.equipment) match = match && e.equipment === observation.equipment;
                                                  if (observation.category) match = match && e.category === observation.category;
                                                  if (observation.check_points) match = match && e.check_points === observation.check_points;
                                                  if (observation.criticality) match = match && e.criticality === observation.criticality;
                                                  if (observation.status) match = match && e.status === observation.status;
                                                  return match;
                                                })
                                                .map((e) => e.legal_reference?.trim())
                                                .filter(Boolean);
                                              const uniqueLegalReferenceList = [...new Set(legalReferences)];
                                              if (uniqueLegalReferenceList.length === 0) return ["N/A"];
                                              return uniqueLegalReferenceList;
                                            }
                                            return [];
                                          })()}
                                          value={observation.legal_reference || ""}
                                          onSelect={(val) =>
                                            handleCellEdit(
                                              { label: val, value: val },
                                              index,
                                              "legal_reference",
                                              observation.legal_reference,
                                              observation
                                            )
                                          }
                                          onFocus={() => handleEditFieldFocus(observation.sr_no, "legal_reference")}
                                          onBlur={() => handleEditFieldBlur(observation.sr_no, "legal_reference")}
                                          onMenuOpen={() => {
                                            if (observation.legal_reference) {
                                              setEditInputValues((prev) => ({
                                                ...prev,
                                                [`${observation.sr_no}-legal_reference`]: observation.legal_reference,
                                              }));
                                            }
                                          }}
                                          menuPortalTarget={document.body}
                                          isDisabled={isFieldDisabled(observation)}
                                        />
                                      </div>
                                    </TableCell>
                                    {/* Max Points */}
                                    <TableCell className="editable-cell" style={{ height: "100px" }}>
                                      <div className="cell-content">
                                        <MultiLineCreatableSelect
                                          placeholder="Max Points"
                                          multiline={false}
                                          allowCreate={false}
                                          isScoring={true}
                                          value={observation?.max_pts ?? 0}
                                          isDisabled={true}
                                        />
                                      </div>
                                    </TableCell>

                                    {/* scores */}
                                    <TableCell className="editable-cell" style={{ height: "100px" }}>
                                      <div
                                        className="cell-content"
                                        style={{
                                          marginRight: "10px",
                                        }}
                                      >
                                        <MultiLineCreatableSelect
                                          multiline={false}
                                          allowCreate={false}
                                          isScoring={true}
                                          value={observation.score ?? ""}
                                          placeholder="Score"
                                          isDisabled={true}
                                        />
                                      </div>
                                    </TableCell>

                                    {/* scores */}
                                    {/* <TableCell className="editable-cell" style={{ height: "100px" }}>
                                      <div
                                        className="cell-content"
                                        style={{

                                          marginRight: "10px",
                                        }}
                                      >
                                        <TextField
                                          type="number"
                                          value={observation.score ?? ""}
                                          placeholder="Score"
                                          sx={{ width: "80px" }}
                                          InputProps={{
                                            sx: { fontSize: "10px" },
                                            inputProps: {
                                              min: 0,
                                              max: 5,
                                              step: 1,
                                            },
                                            disabled:
                                              observation.variant === true ||
                                              (isEditing && currentEditedRow !== observation.sr_no),
                                          }}
                                          onChange={(e) =>
                                            handleScoreChange(
                                              e,
                                              observation.table_type,
                                              observation.sr_no || observation.id,
                                              index
                                            )
                                          }
                                          size="small"
                                          variant="outlined"
                                        />
                                      </div>

                                      {!observation.variant && (
                                        <EditOutlinedIcon
                                          onClick={(e) =>
                                            isEditing
                                              ? setCurrentEditedRow(index)
                                              : null
                                          }
                                          className="edit-icon"
                                          fontSize="small"
                                        />
                                      )}
                                    </TableCell> */}

                                    {/* system_implementation */}
                                    {/* <TableCell className="editable-cell">
                                      <div
                                        className="cell-content"
                                        style={{

                                          marginRight: "10px"
                                        }}
                                      >

                                        <TextField
                                          id={`outlined-textarea-${index}`}
                                          value={observation.system_implementation}
                                          placeholder="System Implentation"
                                          onChange={(e) => {
                                            const newValue = e.target.value;

                                            const proceed = handleCellEdit(
                                              { ...e, target: { ...e.target, textContent: newValue } },
                                              index,
                                              "system_implementation",
                                              observation.system_implementation,
                                              { ...observation, system_implementation: newValue }
                                            );

                                            if (!proceed) return;

                                            setSelectedObservations((prev) =>
                                              prev.map((obs) =>
                                                (obs.sr_no || obs.id) === (observation.sr_no || observation.id)
                                                  ? { ...obs, system_implementation: newValue, hasEdited: true }
                                                  : obs
                                              )
                                            );
                                          }}
                                          onBlur={(e) => {
                                            const latestValue = e.target.value;

                                            handleCellEdit(
                                              { ...e, target: { ...e.target, textContent: latestValue } },
                                              index,
                                              "system_implementation",
                                              observation.system_implementation,
                                              { ...observation, system_implementation: latestValue }
                                            );
                                          }}
                                          sx={{ width: "200px" }}
                                          InputProps={{
                                            sx: { fontSize: "10px" },
                                            disabled: currentEditedRow !== -1 && currentEditedRow !== observation.sr_no,
                                          }}
                                          variant="outlined"
                                          size="small"
                                          fullWidth
                                          multiline
                                          minRows={1.5}
                                          maxRows={10}
                                        />


                                      </div>
                                      {!observation.variant && (
                                        <EditOutlinedIcon
                                          onClick={(e) =>
                                            isEditing
                                              ? handleCellEdit(
                                                e,
                                                index,
                                                "system_implementation",
                                                observation.system_implementation,
                                                observation
                                              )
                                              : null
                                          }
                                          className="edit-icon"
                                          fontSize="small"
                                        />
                                      )}
                                    </TableCell> */}

                                    {/* compliance_check */}
                                    {/* <TableCell className="editable-cell">
                                    <div
                                      className="cell-content"
                                      style={{

                                        marginRight: "10px"
                                      }}
                                    >

                                      <TextField
                                        id={`outlined-textarea-${index}`}
                                        value={observation.compliance_check}
                                        placeholder="compliance_check"
                                        onChange={(e) => {
                                          const newValue = e.target.value;

                                          const proceed = handleCellEdit(
                                            { ...e, target: { ...e.target, textContent: newValue } },
                                            index,
                                            "compliance_check",
                                            observation.compliance_check,
                                            { ...observation, compliance_check: newValue }
                                          );

                                          if (!proceed) return;

                                          setSelectedObservations((prev) =>
                                            prev.map((obs) =>
                                              (obs.sr_no || obs.id) === (observation.sr_no || observation.id)
                                                ? { ...obs, compliance_check: newValue, hasEdited: true }
                                                : obs
                                            )
                                          );
                                        }}
                                        onBlur={(e) => {
                                          const latestValue = e.target.value;

                                          handleCellEdit(
                                            { ...e, target: { ...e.target, textContent: latestValue } },
                                            index,
                                            "compliance_check",
                                            observation.compliance_check,
                                            { ...observation, compliance_check: latestValue }
                                          );
                                        }}
                                        sx={{ width: "200px" }}
                                        InputProps={{
                                          sx: { fontSize: "10px" },
                                          disabled: currentEditedRow !== -1 && currentEditedRow !== observation.sr_no,
                                        }}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        multiline
                                        minRows={1.5}
                                        maxRows={10}
                                      />


                                    </div>
                                    {!observation.variant && (
                                      <EditOutlinedIcon
                                        onClick={(e) =>
                                          isEditing
                                            ? handleCellEdit(
                                              e,
                                              index,
                                              "compliance_check",
                                              observation.compliance_check,
                                              observation
                                            )
                                            : null
                                        }
                                        className="edit-icon"
                                        fontSize="small"
                                      />
                                    )}
                                  </TableCell> */}


                                    {/* photop upload  */}

                                    <TableCell>
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          gap: "15px",
                                        }}
                                      >
                                        {/* <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            padding: "6px 0",
                                            border: "1px solid grey",
                                            borderRadius: "5px",
                                            width: "100px",
                                            cursor: isFieldDisabled(observation)
                                              ? "not-allowed"
                                              : "pointer",
                                            position: "relative",
                                            background: isFieldDisabled(observation)
                                              ? "#f0f0f0"
                                              : "white",
                                            opacity: isFieldDisabled(observation)
                                              ? 0.6
                                              : 1,
                                          }}
                                        >
                                          <CloudUploadOutlinedIcon size={30} />
                                          <input
                                            type="file"
                                            accept="image/jpeg,image/png"
                                            multiple
                                            onChange={(e) =>
                                              handleImageUpload(
                                                observation.table_type,
                                                observation.sr_no || observation.id,
                                                observation.area,
                                                e.target.files
                                              )
                                            }
                                            style={{
                                              position: "absolute",
                                              width: "100%",
                                              height: "100%",
                                              top: 0,
                                              left: 0,
                                              opacity: 0,
                                              cursor: isFieldDisabled(observation)
                                                ? "not-allowed"
                                                : "pointer",
                                            }}
                                            disabled={isFieldDisabled(observation)}
                                          />
                                        </div> */}
                                        <div 
                                          onClick={() => {setOpenGallery(true);setCurrentTableType(tableType);}} 
                                          disabled={isFieldDisabled(observation)} 
                                          style={{
                                              padding: "6px 0px",
                                              border: "1px solid grey",
                                              borderRadius: "5px",
                                              width: "100px",
                                              justifyContent: "center",
                                              alignItems:"center",
                                              display:isFieldDisabled(observation)
                                                ? "none"
                                                : "flex",
                                            }}>
                                          <CloudUploadOutlinedIcon fontSize="30" />
                                        </div>
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            padding: "6px 0",
                                            border: "1px solid grey",
                                            borderRadius: "5px",
                                            width: "100px",
                                            cursor: "pointer",
                                            background: "white",
                                            opacity: 1,
                                          }}
                                          onClick={() =>
                                            handleOpenImageDialog(observation.sr_no || observation.id, observation)
                                          }
                                        >
                                          <InsertPhotoOutlinedIcon size={30} />
                                        </div>
                                      </div>

                                      {selectedObservation?.image &&
                                        selectedObservation.image.sr_no === observation.sr_no && (
                                          <Dialog onClose={handleCloseImageDialog} open={openDialog} maxWidth={false}
                                            PaperProps={{
                                              sx: {
                                                border: "1px solid black",
                                                borderRadius: "10px",
                                              },
                                            }}
                                          >
                                            <DialogTitle>Uploaded Images</DialogTitle>
                                            <DialogContent dividers>
                                              {selectedObservation.image.imageUrls?.length > 0 ? (
                                                <div
                                                  style={{
                                                    display: "grid",
                                                    gridTemplateColumns: "repeat(4, 1fr)",
                                                    gap: "10px",
                                                  }}
                                                >
                                                  {selectedObservation.image.imageUrls.map(
                                                    (imageUrl, imgIndex) => (
                                                      <div style={{ display: "flex" }} key={imgIndex}>
                                                        <img
                                                          src={imageUrl}
                                                          alt={`Image ${imgIndex + 1}`}
                                                          onClick={() => setSelectedImage(imageUrl)}
                                                          style={{
                                                            cursor: "pointer",
                                                            width: "200px",
                                                            height: "200px",
                                                            objectFit: "cover",
                                                            borderRadius: "4px",
                                                          }}
                                                        />
                                                        {(currentEditedRow === selectedObservation?.image?.sr_no) ? <CancelIcon
                                                          className="cancel-icon"
                                                          onClick={() =>
                                                            handleRemoveImage(
                                                              observation.table_type,
                                                              observation.area,
                                                              observation.sr_no || observation.id,
                                                              imgIndex,
                                                              imageUrl,
                                                            )
                                                          }
                                                          // onClick={() => 
                                                          //   handleUnassignBulkImageFromRow(observation.table_type, imageUrl, observation.sr_no)
                                                          // }
                                                          style={{ cursor: "pointer", marginLeft: 5 }}
                                                        />
                                                          : null
                                                        }
                                                      </div>
                                                    )
                                                  )}
                                                </div>
                                              ) : (
                                                <Typography gutterBottom>No File Uploaded</Typography>
                                              )}
                                            </DialogContent>
                                            <DialogActions>
                                              <Button onClick={handleCloseImageDialog}>Close</Button>
                                            </DialogActions>
                                          </Dialog>
                                        )}
                                    </TableCell>



                                    <TableCell className="table-actions">
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                        }}
                                      >
                                        <InfoIcon
                                          onClick={() =>
                                            getObservationVariants(observation.observation, observation.sr_no || observation.id)
                                          }
                                          style={{
                                            pointerEvents: (() => {
                                              const matchingObservation = selectedObservations.find(
                                                (obs) =>
                                                  obs.table_type === observation.table_type &&
                                                  obs.area === observation.area &&
                                                  (obs.sr_no === observation.sr_no || obs.id === observation.id)
                                              );

                                              return isEditing &&
                                                (!matchingObservation ||
                                                  (matchingObservation.sr_no !== observation.sr_no &&
                                                    matchingObservation.id !== observation.id))
                                                ? "none"
                                                : "auto";
                                            })(),
                                          }}
                                        />
                                        {/* Edit/Save Toggle Icon */}
                                        {isEditing && currentEditedRow === observation.sr_no ? (
                                          <CheckIcon
                                            onClick={() => {
                                              console.log('--- onclick CheckIcon')
                                              const emptyFields = [];
                                              if (observation.area === "") emptyFields.push("Area");
                                              if (observation.equipment === "") emptyFields.push("Equipment");
                                              if (observation.category === "") emptyFields.push("Category");
                                              if (observation.check_points === "") emptyFields.push("Checkpoint");
                                              if (observation.criticality === "") emptyFields.push("Criticality");
                                              if (observation.status === "") emptyFields.push("Status");
                                              if (observation.observation === "") emptyFields.push("Observation");
                                              if (observation.recommendations === "") emptyFields.push("Recommendations");
                                              //  if(observation.legal_reference === "") emptyFields.push("Legal Reference");

                                              if (emptyFields.length > 0) {
                                                toast.warning(`${emptyFields.join(", ")} can't be set empty`)
                                                return
                                              }

                                              // Handle legal_reference default to "N/A" if empty
                                              if (observation.legal_reference === "") {
                                                setEditedObservations((prev) => {
                                                  const existingIndex = prev.findIndex(
                                                    (obs) => obs.sr_no === observation.sr_no || obs.id === observation.id
                                                  );
                                                  if (existingIndex !== -1) {
                                                    const updated = [...prev];
                                                    updated[existingIndex] = {
                                                      ...updated[existingIndex],
                                                      legal_reference: "N/A",
                                                    };
                                                    return updated;
                                                  }
                                                  return [...prev, { ...observation, legal_reference: "N/A" }];
                                                });
                                                setSafeGroupedObservations((prev) => {
                                                  const updated = { ...prev };
                                                  if (updated[tableType]) {
                                                    const obsIndex = updated[tableType].findIndex(
                                                      (obs) => obs.sr_no === observation.sr_no || obs.id === observation.id
                                                    );
                                                    if (obsIndex !== -1) {
                                                      updated[tableType][obsIndex] = {
                                                        ...updated[tableType][obsIndex],
                                                        legal_reference: "N/A",
                                                      };
                                                    }
                                                  }
                                                  return updated;
                                                });
                                              }

                                              // Merge editedObservations into selectedObservations and observations
                                              // to persist all column edits when saving the row
                                              if (editedObservations.length > 0) {
                                                setSelectedObservations((prev) => {
                                                  const updated = [...prev];
                                                  editedObservations.forEach((obj) => {
                                                    const srNoOrId = obj.sr_no || obj.id;
                                                    const idx = updated.findIndex(
                                                      (obs) => obs.sr_no === srNoOrId || obs.id === srNoOrId
                                                    );
                                                    if (idx !== -1) {
                                                      updated[idx] = {
                                                        ...obj,
                                                        ...(obj.legal_reference === "" ? { legal_reference: "N/A" } : {}),
                                                      };
                                                    }
                                                  });
                                                  return updated;
                                                });
                                                setObservations((prev) => {
                                                  const updated = [...prev];
                                                  editedObservations.forEach((obj) => {
                                                    const srNoOrId = obj.sr_no || obj.id;
                                                    const idx = updated.findIndex(
                                                      (obs) => obs.sr_no === srNoOrId || obs.id === srNoOrId
                                                    );
                                                    if (idx !== -1) {
                                                      updated[idx] = {
                                                        ...obj,
                                                        is_selected: 1,
                                                        ...(obj.legal_reference === "" ? { legal_reference: "N/A" } : {}),
                                                      };
                                                    }
                                                  });
                                                  return updated;
                                                });
                                                setEditedObservations([]);
                                              }

                                              setIsEditing(false);
                                              setCurrentEditedRow(-1);
                                              toast.success("Row changes saved. You can now edit other rows.");
                                              setNewObservationAdded(true)
                                            }}
                                            style={{
                                              cursor: "pointer",
                                              color: "green",
                                              marginLeft: "8px",
                                              marginRight: "8px",
                                            }}
                                            titleAccess="Save changes and exit edit mode"
                                          />
                                        ) : (
                                          <EditOutlinedIcon
                                            onClick={() => {
                                              console.log('--- onclick EditOutlinedIcon')
                                              if (observation.isNew) {
                                                handleEditNewRow(observation);
                                              } else {
                                                console.log('--- onclick EditOutlinedIcon existing')
                                                if (isEditing && currentEditedRow !== -1 && currentEditedRow !== observation.sr_no) {
                                                  const unsavedRow = selectedObservations.find(
                                                    (obs) => obs.sr_no === currentEditedRow || obs.id === currentEditedRow
                                                  );
                                                  const unsavedTableType = unsavedRow?.table_type || "another table";
                                                  const unsavedRowIndex = safeGroupedObservations[unsavedTableType]
                                                    ? safeGroupedObservations[unsavedTableType].findIndex(
                                                      (obs) => obs.sr_no === currentEditedRow || obs.id === currentEditedRow
                                                    )
                                                    : -1;
                                                  const unsavedSrNo = unsavedRowIndex !== -1 ? unsavedRowIndex + 1 : null;

                                                  toast.warning(
                                                    unsavedSrNo
                                                      ? `You have an unsaved observation at row ${unsavedSrNo} in "${unsavedTableType}". Please save it before editing another row.`
                                                      : `You have an unsaved row in "${unsavedTableType}". Please save it before editing another row.`
                                                  );
                                                  return;
                                                }
                                                setIsEditing(true);
                                                setCurrentEditedRow(observation.sr_no);
                                                setIsReportEdited(true);
                                              }
                                            }}
                                            style={{
                                              cursor: (isEditing && currentEditedRow !== -1 && currentEditedRow !== observation.sr_no)
                                                ? "not-allowed"
                                                : "pointer",
                                              color: (isEditing && currentEditedRow !== -1 && currentEditedRow !== observation.sr_no)
                                                ? "grey"
                                                : "#1976d2",
                                              marginLeft: "8px",
                                              marginRight: "8px",
                                            }}
                                            titleAccess="Edit row"
                                          />
                                        )}
                                        <DeleteForeverIcon
                                          onClick={() =>
                                            handleDeleteRow(
                                              observation.table_type,
                                              observation.area,
                                              observation.sr_no || observation.id
                                            )
                                          }
                                          style={{ cursor: "pointer" }}
                                        />
                                      </div>
                                    </TableCell>
                                  </TableRow>
    );
  },
  (prevProps, nextProps) => {
    const o1 = prevProps.observation;
    const o2 = nextProps.observation;
    if (
      o1.sr_no !== o2.sr_no ||
      o1.id !== o2.id ||
      o1.area !== o2.area ||
      o1.equipment !== o2.equipment ||
      o1.category !== o2.category ||
      o1.check_points !== o2.check_points ||
      o1.criticality !== o2.criticality ||
      o1.status !== o2.status ||
      o1.observation !== o2.observation ||
      o1.recommendations !== o2.recommendations ||
      o1.legal_reference !== o2.legal_reference ||
      o1.max_pts !== o2.max_pts ||
      o1.score !== o2.score ||
      o1.variant !== o2.variant ||
      o1.isNew !== o2.isNew ||
      o1.image !== o2.image
    ) {
      return false;
    }
    // imageUrls isn't covered by the field checks above. Without this, uploading
    // (or removing) an image doesn't re-render the row, so the preview dialog's
    // onClick captures a stale observation and shows the wrong image list until
    // a later render. Compare length + contents so add/remove both trigger a render.
    const u1 = o1.imageUrls || [];
    const u2 = o2.imageUrls || [];
    if (u1.length !== u2.length || u1.some((v, i) => v !== u2[i])) {
      return false;
    }
    if (prevProps.index !== nextProps.index) return false;
    if (prevProps.tableType !== nextProps.tableType) return false;
    if (prevProps.isEditing !== nextProps.isEditing) return false;
    if (prevProps.allData !== nextProps.allData) return false;
    const wasEdited =
      prevProps.currentEditedRow === o1.sr_no || prevProps.currentEditedRow === o1.id;
    const isEdited =
      nextProps.currentEditedRow === o2.sr_no || nextProps.currentEditedRow === o2.id;
    if (wasEdited !== isEdited) return false;
    if (
      isEdited &&
      (prevProps.areaList !== nextProps.areaList ||
        prevProps.equipmentList !== nextProps.equipmentList ||
        prevProps.hseCategoryList !== nextProps.hseCategoryList ||
        prevProps.checkpointList !== nextProps.checkpointList)
    ) {
      return false;
    }
    const thisRowDialog =
      nextProps.selectedObservation?.image?.sr_no === o2.sr_no ||
      prevProps.selectedObservation?.image?.sr_no === o1.sr_no;
    if (
      thisRowDialog &&
      (prevProps.openDialog !== nextProps.openDialog ||
        prevProps.dialog !== nextProps.dialog ||
        prevProps.selectedObservation !== nextProps.selectedObservation)
    ) {
      return false;
    }
    return true;
  }
);

HseObservationRow.displayName = 'HseObservationRow';

export default HseObservationRow;
